module.exports = __webpack_public_path__ + "img/activity_ico3.e21101d8.png";